<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <ValidationProvider
            id="voucher_code"
            v-slot="{ errors }"
            name="voucher_code"
            rules="required"
          >
            <v-text-field
              v-model="voucherCode"
              label="Voucher code"
              color="primary"
              :error-messages="errors"
            />
            <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p>
          </ValidationProvider>

          <v-btn
            rounded
            depressed
            color="primary"
            type="submit"
            :loading="buttonLoading"
            @click="passes(redeemVoucher)"
            ><span>Redeem voucher</span
            ><v-icon small>{{ icons.mdiArrowRight }}</v-icon></v-btn
          >
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { REDEEM_VOUCHER_MUTATION } from '../../constants/graphql/vouchers';

  export default {
    name: 'RedeemVoucherOnceOff',
    props: {
      paymentPlan: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        voucherCode: null,
        buttonLoading: false,
        errorMessage: null,
      };
    },
    methods: {
      redeemVoucher() {
        this.buttonLoading = true;
        const code = this.voucherCode;
        const testatorId = this.testatorId;
        const paymentPlan = this.paymentPlan;

        this.$apollo
          .mutate({
            mutation: REDEEM_VOUCHER_MUTATION,
            variables: {
              code,
              testatorId,
              paymentPlan,
            },
          })
          .then(response => {
            if (response.data.redeemVoucher.success) {
              this.$router.push('/success-payment');
              this.gtm_tracking(response.data.redeemVoucher);
            } else {
              this.errorMessage = 'Something went wrong';
            }
            this.buttonLoading = false;
          })
          .catch(error => {
            this.buttonLoading = false;
            this.errorMessage = error.message
              .replace('GraphQL error:', '')
              .trim();
          });
      },
      gtm_tracking(redeemVoucherResponse) {
        this.$gtm.trackEvent({
          event: 'successful-payment',
          category: 'Payment',
          action: 'Voucher',
          label: { transactionId: redeemVoucherResponse.transactionId },
          value: redeemVoucherResponse.amount,
        });
      },
    },
  };
</script>
